window.StatisticsSingle = (function () {
    var selectors = {
        externalStatistics: '[show-estat]'
    };

    var lastEventId,
		modalWin;

    function bindUI() {
        $('body').on('click', selectors.externalStatistics, function () {
        var externalId = Number($(this).attr('show-estat'));

            if (!isNaN(externalId)) {
                showExternalStatistics(externalId);
            }
        });

        document.addEventListener('statBtnIsClicked', function (e) {
            if(e.detail.statId) {
                showExternalStatistics(e.detail.statId);
            }
        });
}

    var showExternalStatistics = function (newEventId) {
        if (newEventId !== lastEventId) {
            modalWin.updateContent({
                content: `<iframe src="${globalAppSettings.matchStatLink.replace("(eventId)", newEventId)}" width="1280px" height="790px" style="border: none;"></iframe>
                    <div class="modal-statistics-baltstat-logo">
                        <a href="${globalAppSettings.generalStatLink}" target="_blank" rel="norefferer">
                            <span>${window.Localization.getString('Scripts_Shared_Modules.StatisticsGeneral_30', 'Статистика предоставлена')}</span>
                            <svg class="icon icon-baltstat"><use xlink:href="${globalAppSettings.svg.defaultSprite}#baltstat"></use></svg>
                        </a>
                    </div>`
            });
            lastEventId = newEventId;
        }
        modalWin.show();
    };

    function init() {
        if (globalAppSettings.isStatisticsEnabled === false)
            return;

        modalWin = new ModalWindow({
            title: Localization.getString('Events.Statistic','Статистика'),
            content: '',
            className: 'm-modal-win-statistics-single'
        });

        modalWin.generateDOM();
        modalWin.bindUIActions();

        modalWin.show = function () {
            this.dom.overlay.fadeIn(200);
            this.updateDimension();
        };

        modalWin.hide = function () {
            this.dom.overlay.fadeOut(200);
        };

        bindUI();
    }

    return {
        init: init,
        //show: show,
        //mw: () => { return modalWin; }
    };
}());

$(function () {
    window.StatisticsSingle.init();
});